import React, { FC } from "react";
import { CiSquareMinus, CiSquarePlus } from "react-icons/ci";
import { MdOutlineMailLock } from "react-icons/md";
import { RiLockPasswordLine } from "react-icons/ri";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import "./style.scss";

import SemImagemSmall from "../../../../../assets/images/sem-imagem-small.jpg";

type Props = {
  isExpanded: boolean;
  item: {
    role: string;
    name: string;
    email: string;
    photo: string;
    username: string;
  };
  onResetPassword: () => void;
  onResetEmailPassword: () => void;
};


const RowInfo: FC<Props> = ({ isExpanded, item, onResetPassword, onResetEmailPassword }) => {
  const redefinirSenha = (props: any) => (
    <Tooltip id="tooltip-reset" {...props}>
      Redefinir Senha
    </Tooltip>
  );

  const emailSenha = (props: any) => (
    <Tooltip id="tooltip-email" {...props}>
      Enviar um e-mail para o aluno redefinir a senha.
    </Tooltip>
  );

  return (
    <>
      <div className="row-info-base">
        <div className="row-info">
          {isExpanded ? <CiSquareMinus /> : <CiSquarePlus />}
          <img
            alt="manager-profile"
            className="manager-profile"
            src={item.photo || SemImagemSmall}
          />
          <div className="title-team">
            <p className="name">{item.name}</p>
            <p className="role"> {item.role ? item.role.toUpperCase() : ""}</p>
          </div>
        </div>

        <div className="row-info-control">
          <OverlayTrigger placement="top" delay={{ show: 0, hide: 0 }} overlay={redefinirSenha}>
            <button
              onClick={(e) => {
                e.stopPropagation();
                onResetPassword?.();
              }}
              title="Redefinir senha"
            >
              <RiLockPasswordLine style={{ fontSize: 22 }} />
            </button>
          </OverlayTrigger>
          <OverlayTrigger placement="top" delay={{ show: 0, hide: 0 }} overlay={emailSenha}>
            <button
              onClick={(e) => {
                e.stopPropagation();
                onResetEmailPassword?.();
              }}
              title="Enviar e-mail de redefinição"
            >
              <MdOutlineMailLock style={{ fontSize: 22 }} />
            </button>
          </OverlayTrigger>
        </div>
      </div>
    </>
  );
};

export default RowInfo;
